module.exports = __webpack_public_path__ + "img/logo.57ec067f.webp";